import type { StateCreator } from 'zustand';
import sheetImportSlice, { type SheetImportSliceState } from './sheetImportSlice';

type SheetImportSlices = SheetImportSliceState;

const sheetImportSlices: StateCreator<SheetImportSlices, [['zustand/devtools', never]]> = (setState, getState, store) => ({
  ...sheetImportSlice(setState, getState, store),
});

export type { SheetImportSlices };
export default sheetImportSlices;
